<template>
  <gj-popover
      placement="right-start"
      trigger="hover"
      :open-delay="500"
      :close-delay="100"
      lazy
  >
    <div v-loading="loading" class="gj-normal-img">
      <img :src="normalImgUrl" @load="load()" :style="normalImgStyle" />
       <!-- <gj-button v-if="!showOriginImage" size="small" class="gj-normal-img-btn" @click="showOriginNormalImg">查看原图</gj-button> -->
    </div>
    <template slot="reference">
      <div style="display: inline-block; position: relative;">
        <img :src="imgSrc" :style="imgStyle"/>
        <gj-tag v-if="tag" type="plain" :color="tagColor" class="gj-img--tag">{{ tag }}</gj-tag>
      </div>
    </template>
  </gj-popover>
</template>

<script>
const defaultImg = require('../../assets/images/default-img.png');

export default {
  name: "gj-image",
  props: {
    src: {
      type: String
    },
    size: {
      default: 40
    },
    zoomSize: {
      default: 200
    },
    tag: {
      default: null
    },
    tagColor: {
      default: null
    }
  },
  data() {
    return {
      loading: true,
      // 是否显示原始图片
      showOriginImage: false,
      defaultImg,
    }
  },
  computed: {
    imgSrc() {
      let src = this.src;
      if (src && src.indexOf('lingyin.tongtool.com') > -1) {
        src = 'https://images.weserv.nl/?url=' + src
      } else if (src && src.indexOf('m.media-amazon.com') > -1 && src.indexOf('._SL75_') == -1) {
        const strFilter = /(.jpeg|.gif|.jpg|.png|.bmp|.pic|.svg)$/
        src = this.src.replace(strFilter, ($1)=>{
          return '._SL75_' + $1
        })
      }
      return src || defaultImg
    },
    imgStyle() {
      return {width: `${this.size}px`, height: `${this.size}px`}
    },
    normalImgUrl() {
      let src = this.src ? this.src.replace('._SL75_', '') : null;
      if (src && src.indexOf('lingyin.tongtool.com') > -1) {
        src = 'https://images.weserv.nl/?url=' + src
      }
      return src || defaultImg
    },
    normalImgStyle() {
      return this.showOriginImage ? {} : {width: `${this.zoomSize}px`, height: `${this.zoomSize}px`}
    },
  },
  methods: {
    load() {
      this.loading = false;
    },
    showOriginNormalImg() {
      // 显示原图大小
      this.showOriginImage = true;
    }
  }
}
</script>

<style scoped lang="scss">
.gj-normal-img {
  display: flex;
  flex-direction: column;
  align-items: center;

  &-btn {
    margin-top: 12px;
  }
}

.gj-img--tag {
  position: absolute;
  left: -2px;
  top: -4px;
}
.gj-img--inner {
  border: 1px solid rgba(70, 70, 70, 0.1);
  border-radius: 2px;
}
</style>
